export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.1,
      duration: 0.5
    }
  })
};

export const flipCardVariants = {
  front: { rotateY: 0 },
  back: { rotateY: 180 },
  transition: { duration: 0.6, ease: "easeOut" }
};